<template>
  <ul class="page-footer" v-if="isFooter">
    <li>
      <p>服务专线 0579-87586666</p>
      <p>服务专线 0579-87586666</p>
    </li>
    <li>产投 “义利帮” 企业服务平台</li>
  </ul>
</template>

<script>
export default {
  name: "page-footer",
  data() {
    return {
      isFooter: true,
    };
  },
  watch: {
    $route: {
      handler(to) {
        to.path == "/user-login"
          ? (this.isFooter = false)
          : (this.isFooter = true);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer {
  @include inheritWH(percent, $footer-height);
  @include crosswise;
  align-items: center;
  padding: 0 240px;
  background-color: #292d38;

  & li p,
  & li {
    color: $txt-color;
    font-size: 14px;
  }

  & > li:first-child > p:first-child {
    margin-bottom: 10px;
  }
}
</style>
